import React, { Fragment } from "react"
import styled, { css } from "react-emotion"
import { withTheme } from "emotion-theming"
import Modal from "react-modal"

import Button from "./Button"
import Divider from "./Divider"
import Section from "./Section"
import Container from "./Container"

class ButtonModal extends React.Component {
    state = {
        contents: {},
    }

    close = () => this.setState({ open: false })
    open = () => this.setState({ open: true })

    render() {
        const modalStyle = css`
            background-color: ${this.props.theme.surfaceColor};
            border-radius: ${this.props.theme.elementBorderRadius};
            padding: ${this.props.theme.large};
            padding-bottom: ${this.props.theme.medium};
            box-shadow: ${this.props.theme.elementShadow};
            border: ${this.props.theme.elementBorder};
            max-height: 700px;
            max-width: 900px;
            height: 100%;
            width: 100%;
            margin: calc((100vh - 700px) / 2 - 32px) auto;
            z-index: 10;
            position: relative;
            display: flex;
            flex-direction: column;
            &:focus {
                outline: none;
            }

            @media screen and (max-height: 768px) {
                max-height: 500px;
                margin: calc((100vh - 500px) / 2 - 32px) auto;
            }

            ${this.props.dialog &&
                `
            height: unset;
            max-width: 600px;
            margin: calc((100vh - 500px) / 2 - 32px) auto;

            & hr {
                display: none;
            }
            `};
        `
        const overlayStyle = css`
            position: fixed;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            background-color: rgba(100, 100, 100, 0.75);
            z-index: 5;
            padding: ${this.props.theme.medium};
        `
        let defaultButton = (
            <Button onClick={this.open} {...this.props}>
                {this.props.label}
            </Button>
        )
        const setContentsState = state => {
            this.setState.bind(this)({ contents: state })
        }
        const renderProps = {
            open: this.open,
            close: this.close,
            setState: setContentsState,
            state: this.state.contents,
        }

        let button = this.props.button ? this.props.button(renderProps) : defaultButton
        let header = this.props.header && this.props.header(renderProps)
        let footer = this.props.footer && this.props.footer(renderProps)
        let contents = this.props.children && this.props.children(renderProps)
        let marginSize = this.props.dialog ? "none" : "large"
        return (
            <Fragment>
                {button}
                <Modal
                    className={modalStyle}
                    overlayClassName={overlayStyle}
                    isOpen={this.state.open}
                    onRequestClose={this.close}
                >
                    <Container>
                        <ModalHeader className={this.props.headerClassName}>{header}</ModalHeader>

                        <Button margin="none" round onClick={this.close}>
                            <i class="fal fa-times" />
                        </Button>
                    </Container>
                    <Divider />
                    <Section
                        maxSize={1}
                        margin={marginSize}
                        className={this.props.contentClassName}
                    >
                        {contents}
                    </Section>
                    <Section bottom margin={footer ? "none" : marginSize} padding={marginSize}>
                        <Divider />
                        <Container className={this.props.footerClassName}>{footer}</Container>
                    </Section>
                </Modal>
            </Fragment>
        )
    }
}

ButtonModal.displayName = "ButtonModal"

export default withTheme(ButtonModal)

const ModalHeader = styled("div")`
    font-size: ${props => props.theme.headingTwoSize};
    color: ${props => props.theme.headingColor};
    font-weight: ${props => props.theme.headingWeight};
    font-family: ${props => props.theme.headingFont};
    margin: ${props => props.theme.small} 0px;
    flex-grow: 1;
`



// WEBPACK FOOTER //
// ./src/ui/components/ButtonModal.js